import React from 'react';
import pluralize from 'pluralize';
import pluralizeEs from 'pluralize-es';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';

const useRenderExampleSentence = () => {
  const locale = useSlideShowContext(state => state.locale);

  return (sentence: string | null, keyword: string, id: string | number) => {
    if (!sentence) return null;

    const keywordSingular = locale === 'es' ? keyword : pluralize.singular(keyword);
    const keywordPlural = locale === 'es' ? pluralizeEs(keyword) : pluralize(keyword);
    const escapeRegex = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`\\b(${escapeRegex(keywordSingular)}|${escapeRegex(keywordPlural)})\\b`, 'gi');

    const occurrenceCount: { [key: string]: number } = {};
    return sentence.split(regex).map((part) => {
      const lowerPart = part.toLowerCase();
      occurrenceCount[lowerPart] = (occurrenceCount[lowerPart] || 1) + 1;
      const uniqueKey = `${id}-${lowerPart}-${occurrenceCount[lowerPart]}`;

      return lowerPart === keywordSingular.toLowerCase() || lowerPart === keywordPlural.toLowerCase()
        ? <strong key={uniqueKey}>{part}</strong>
        : part;
    });
  };
};

export default useRenderExampleSentence;
